<template>
    <v-card>
        <v-card-title>Edit Relationship Config</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="3">
                    <v-autocomplete
                        :items="allRegistrySchemas"
                        label="Registry"
                        clearable
                        v-model="selectedRegistrySchema"
                        item-title="displayName"
                        return-object
                    />
                </v-col>
                <v-col cols="2">
                    <v-checkbox label="Required?"
                                v-model="required"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <!-- Note: I tried combining these, but it'd end up with dupes showing in the UI-->
                    <v-autocomplete
                        v-if="allowMultiple"
                        :disabled="!selectedRegistrySchema"
                        :items="registryEntries"
                        :multiple="true"
                        label="Default Relationship"
                        clearable
                        v-model="defaultRelationshipRegistryEntryIds"
                        item-title="displayName"
                        item-value="id"
                    />
                    <v-autocomplete
                        v-if="!allowMultiple"
                        :disabled="!selectedRegistrySchema"
                        :items="registryEntries"
                        label="Default Relationship"
                        clearable
                        v-model="defaultRelationshipRegistryEntryId"
                        item-title="displayName"
                        item-value="id"
                    />
                </v-col>
                <v-col cols="2">
                    <v-checkbox label="Allow multiple?"
                                v-model="allowMultiple"/>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="cancel">Cancel</v-btn>
            <v-btn color="primary" @click="saveRelationshipConfig">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script setup lang="ts">

import { SavedRegistrySchema } from "@/services/registries/registriesAPI";
import { withRelationshipConfigForm } from "@/components/ExperimentRelationshipConfigs/relationshipConfigComposable";
import {
    ExperimentSetupRelationshipConfig,
    SavedExperimentSetupRelationshipConfig,
} from "@/services/experimentRelationships/models";

const { allRegistrySchemas, type, experimentRelationshipConfigToEdit } = defineProps<{
    allRegistrySchemas: SavedRegistrySchema[];
    type: string;
    experimentRelationshipConfigToEdit?: SavedExperimentSetupRelationshipConfig;
}>();

const emit = defineEmits<{
    (e: "saveExperimentRelationshipConfig", targetConfig: ExperimentSetupRelationshipConfig | SavedExperimentSetupRelationshipConfig): void;
    (e: "cancelEditRelationshipConfig"): void;
}>();

function saveRelationshipConfig() {
    const config = buildBaseRelationshipConfig();
    emit("saveExperimentRelationshipConfig", config);
}

function cancel() {
    emit("cancelEditRelationshipConfig");
}

const {
    selectedRegistrySchema,
    required,
    allowMultiple,
    registryEntries,
    defaultRelationshipRegistryEntryIds,
    defaultRelationshipRegistryEntryId,
    buildBaseRelationshipConfig,
    init,
} = withRelationshipConfigForm(allRegistrySchemas, type, experimentRelationshipConfigToEdit);

init();

</script>
